import {
   ConversationTranscript as ApiConversationTranscript,
   ConversationUtterance,
   FeatureNotEnabledFault,
   PromptTimeoutFault,
   PromptUnavailableFault,
   QuotaExceededFault,
   VisitTranscriptSummarizeCommand,
   VisitTranscriptSummaryResult,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { AI_ASSISTANT_FAULT_HANDLERS } from './faultHandlers';

export type { VisitTranscriptSummaryResult };

export type VisitTranscriptSummaryInput = {
   utterances: Array<{ speaker: string; text: string }>;
   specialisation?: string;
};

type SummaryFaultUnion = FeatureNotEnabledFault | QuotaExceededFault | PromptUnavailableFault | PromptTimeoutFault;

type UseVisitTranscriptSummaryOptions = {
   onSuccess?: (result: VisitTranscriptSummaryResult) => void;
};

export const useVisitTranscriptSummary = (
   options: UseVisitTranscriptSummaryOptions = {}
): UseCqrsCommandResult<VisitTranscriptSummaryResult, VisitTranscriptSummaryInput, SummaryFaultUnion> => {
   return useCqrsCommand<VisitTranscriptSummaryResult, VisitTranscriptSummaryInput, SummaryFaultUnion>(
      (input) => {
         const command = new VisitTranscriptSummarizeCommand();
         const transcript = new ApiConversationTranscript();
         transcript.utterances = input.utterances.map((utterance) => {
            const item = new ConversationUtterance();
            item.speaker = utterance.speaker;
            item.text = utterance.text;
            return item;
         });
         command.transcript = transcript;
         if (input.specialisation !== undefined) {
            /*
             * `specialisation` is not yet in the generated API type.
             * Use Object.assign so TypeScript doesn't silently widen the type
             * via a double cast, and the property is still sent on the wire.
             * Remove once @dreryk/egabinet-ai-assistant-frontend-api adds the field.
             */
            Object.assign(command, { specialisation: input.specialisation });
         }
         return command;
      },
      {
         onSuccess: options.onSuccess,
         onFault: { ...AI_ASSISTANT_FAULT_HANDLERS },
      }
   );
};
